<div class="p-4 text-center">
    <h1 class="mb-2">
        <!-- Need to load from DB -->
        Version : 1.0.4.4 
    </h1>
    <h5 class="text-center">
      <!-- Need to load from DB -->
      © 2026 KPMG LLP, a Delaware limited liability partnership, and its subsidiaries are part of the KPMG global organization of
      independent member firms affiliated with KPMG International Limited, a private English company limited by guarantee.
      All rights reserved.
    </h5>
</div>
